/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Event_Index_HeaderInputs */

const en_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Index`)
};

const fr_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index de l'événement`)
};

const de_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisindex`)
};

const it_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indice degli eventi`)
};

const ru_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индекс событий`)
};

const es_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice de eventos`)
};

const zh_cn2_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件索引`)
};

const ja_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントインデックス`)
};

const hi_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना सूचकांक`)
};

const pt_pt2_compare_event_groups_csv_event_index_header = /** @type {(inputs: Compare_Event_Groups_Csv_Event_Index_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice de eventos`)
};

/**
* | output |
* | --- |
* | "Event Index" |
*
* @param {Compare_Event_Groups_Csv_Event_Index_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_event_index_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Event_Index_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Event_Index_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_event_index_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_event_index_header(inputs)
	return en_compare_event_groups_csv_event_index_header(inputs)
});